<template>
  <div>
    <helpers-section-header class="mt-6 mb-2">WhaleML Signal Rules</helpers-section-header>
    <p class="text-body-2 mb-2">
      WhaleML uses a machine-learning model trained on institutional 13F filing data and
      fundamental stock features to predict which stocks are likely to generate
      <strong>alpha over the S&amp;P 500</strong>. Scores are updated <strong>once per week</strong>
      and range from <strong>0 to 1</strong>: a score closer to <strong>1</strong> means the model
      has high confidence that the stock will outperform the index, while a score near <strong>0</strong>
      suggests underperformance.
    </p>
    <p class="text-body-2 mb-4">
      Set a <strong>minimum score</strong> to control how selective long signals are — for example,
      a threshold of <code>0.65</code> means only stocks where the model is at least 65% confident
      of outperformance will generate a buy signal.
    </p>

    <v-checkbox v-model="criteria.long_enabled" label="Allow Long Signals" hide-details density="compact" class="mb-4" />

    <v-row>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
          v-model="criteria.min_score"
          :disabled="!criteria.long_enabled"
          label="Min score for long signals"
          type="number"
          min="0"
          max="1"
          step="0.01"
          variant="outlined"
          density="compact"
          hint="Buy when score ≥ this value (0–1). Higher = more selective."
          persistent-hint
        />
      </v-col>
    </v-row>

    <helpers-section-sub-header class="mt-6">Signal Evaluation Window</helpers-section-sub-header>
    <p class="text-body-2 mb-2">
      How many days after a score is first published to continue treating it as an active buy
      signal. Since scores are refreshed weekly, setting this to <strong>7</strong> keeps each
      signal active until the next weekly update. Set higher to hold signals across multiple
      weekly updates.
    </p>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="criteria.number_of_days_to_evaluate"
          label="Days to keep signal active"
          suffix="days"
          variant="outlined"
          density="compact"
          hint="7 = active until the next weekly score update"
          persistent-hint
          style="max-width: 250px"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapWritableState } from 'pinia'
import { useAppStore } from '@/store'
export default {
  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria']),
    criteria() {
      return this.whaleTraderCriteria.signals.whaleml_signal
    }
  }
}
</script>
